class CustomiserSplash extends HTMLElement {
  constructor() {
    super()
    this.parent = this.parentElement

    this.ui = {
      label: this.querySelector('.splash-screen__cta'),
      images: this.querySelectorAll('img'),
    }
  }

  connectedCallback() {
    this.animateIn()

    setTimeout(() => {
      this.loadingAnimation?.kill()
      this.parent.hideLoadingScreen()
    }, 5000)
  }

  disconnectedCallback() {
    this.loadingAnimation?.kill()
  }

  loadingAnimation() {
    this.object = {
      i: 0,
    }

    this.loadingAnimation = gsap
      .timeline({ repeat: -1, repeatDelay: 0.2, delay: 0.5 })
      .to(this.ui.images, {
        opacity: 0,
        stagger: -0.25,
        ease: 'none',
        duration: 0.2,
        repeat: 1,
        yoyo: true,
      })
      .to(this.object, { i: 2 }, '+=0.2')
  }

  animateIn() {
    return gsap
      .timeline({ paused: true, onComplete: () => this.loadingAnimation() })
      .fromTo(
        this.ui.images,
        { opacity: 0 },
        {
          opacity: 1,
          stagger: 0.2,
          ease: 'none',
          duration: 0.3,
        },
        0
      )
      .fromTo(this.ui.label, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 }, 0)
      .restart()
  }

  animateOut() {
    return gsap
      .timeline({ paused: true })
      .fromTo(this, { autoAlpha: 1 }, { autoAlpha: 0, duration: 0.5 })
      .restart()
  }
}

if (!customElements.get('customiser-splash')) {
  customElements.define('customiser-splash', CustomiserSplash)
}
